import { render } from "./iPhone.vue?vue&type=template&id=2a1499b2&scoped=true"
import script from "./iPhone.vue?vue&type=script&lang=js"
export * from "./iPhone.vue?vue&type=script&lang=js"

import "./iPhone.vue?vue&type=style&index=0&id=2a1499b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1499b2"]])

export default __exports__